/**
 * @TODO: revisit this when we refactoring for the container/component pattern
 */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getOffsetTop, getElementHeight, getWindowHeight } from 'ctm-util-functions';
import {
    pageShowPleaseWaitSelector,
    browserMediaTypeSelector,
    sortedAndFilteredProductsSelector
} from 'ctm-selectors';

import { ScrollTo } from './scroll_to';

/**
 * Scroll to component
 * @desc ScrollTo will allow users to scroll to top and bottom of results pages.
 * @returns {ScrollTo} A button that will either scroll to top or bottom of pages.
 */
class _ScrollToContainer extends Component {

    /**
     * Update the component when having quotes so can ensure that resultsContainer has dimensions.
     */
    componentDidMount = () => {
        const { quotes } = this.props;
        if (quotes.size) {
            this.forceUpdate();
        }
    };

    /**
     * Get the dimensions to be passed to the ScrollTo component.
     * @returns {Object} - The dimensions.
     */
    getDimensions = () => {
        /**
         * Exit early if server-side rendering.
         * Ain't no document object on the server-side.
         */
        const isSSR = typeof document === 'undefined';
        if (isSSR) {
            return null;
        }

        const resultsPage = document.getElementById('resultsContainer');
        const anchorMargin = 40; // the anchors container marginTop + marginBottom
        const windowHeight = getWindowHeight();
        const resultsPageHeight = getElementHeight(resultsPage);
        const resultsPageOffsetTop = getOffsetTop(resultsPage);
        const anchorOffsetTop = (resultsPageHeight + resultsPageOffsetTop) - anchorMargin;
        const documentHeight = getElementHeight(window.document);
        // Get the position of the anchor from the bottom of the document.
        const anchorFromBottom = documentHeight - (documentHeight - anchorOffsetTop);
        // Get the current height relative to the anchor
        const currentHeight = anchorFromBottom - windowHeight;

        // return the dimensions
        return { documentHeight, windowHeight, anchorOffsetTop, currentHeight };
    };

    /**
     * The render method
     * @returns {Node} An empty div or the scroll to button, wrapped in the scroll wrapper.
     */
    render = () => {
        const {
            quotes,
            showPleaseWait,
            visualProps,
            elementProps,
            contentProps,
            mediaType
        } = this.props;
        const dimensions = this.getDimensions();

        if (quotes.size && !showPleaseWait && dimensions) {
            return (
                <ScrollTo
                    visualProps={visualProps}
                    elementProps={elementProps}
                    contentProps={contentProps}
                    mediaType={mediaType}
                    dimensions={dimensions}
                />
            );
        }
        return null;
    };

}

_ScrollToContainer.propTypes = {
    quotes: PropTypes.object,
    showPleaseWait: PropTypes.bool,
    visualProps: PropTypes.object,
    elementProps: PropTypes.object,
    contentProps: PropTypes.object,
    mediaType: PropTypes.string
};

/**
 * Map rules and snippets from state to props
 * @param {Object} state - The application state
 * @param {Object} props - The page props
 * @returns {Object} - The state values to be added to props for the page
 */
const mapStateToProps = (state, props) => {
    const quotes = sortedAndFilteredProductsSelector(state);

    return {
        quotes,
        showPleaseWait: pageShowPleaseWaitSelector(state),
        mediaType: browserMediaTypeSelector(state)
    };
};

export const ScrollToContainer = connect(mapStateToProps)(_ScrollToContainer);
